export enum DEVICE {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  ALL = 'all',
}
